import groq from 'groq';
import { innerBlocksFieldsData, outerBlocksFieldsData } from '../blocks/config.web';

const ignoreFieldsGroq = ['', '...', '...,'];

const innerBlocksGroq = innerBlocksFieldsData
  .map((innerBlock) => {
    // If inner block doesn't need any special field query, then it will be empty or just some dots, so ignore it.
    return (innerBlock.fields && !ignoreFieldsGroq.includes(innerBlock.fields.trim()))
      ? groq`_type == "${innerBlock.name}"=>{${innerBlock.fields ?? ''}}`
      : groq``;
  })
  .filter((groqString) => groqString.length !== 0)
  .join(',');


export const innerContentBlockFields = groq`
  ...,
  ${innerBlocksGroq}
`;

const outerBlocksGroq = outerBlocksFieldsData
  .map((outerBlock) => {
    // If outer block doesn't need any special field query, then it will be empty or just some dots, so ignore it.
    return (outerBlock.fields && !ignoreFieldsGroq.includes(outerBlock.fields.trim()))
      ? groq`_type == "${outerBlock.name}"=>{ ${outerBlock.fields ?? ''} }`
      : groq``;
  })
  .filter(groqString => groqString.length !== 0)
  .join(',');

// Outer blocks nest inners under `content[]`. Some documents (e.g. business homepage)
// store inner blocks at the top level of `content[]`, so also project inner fields here.
export const modularContentBlocks = groq`
  ...,
  content[] {
    ${innerContentBlockFields}
  },
  ${outerBlocksGroq},
  ${innerBlocksGroq}
`;
